/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { P as Popover, d as defineCustomElement$1 } from './popover.js';

const IonPopover = Popover;
const defineCustomElement = defineCustomElement$1;

export { IonPopover, defineCustomElement };
